const getImages = document.querySelectorAll(".golive--image"); 
const goliveMainContainer = document.getElementById("golive--images");
const footerHeight= document.documentElement.getElementsByTagName("footer")[0].offsetHeight;
const footerPromotion = document.querySelector(".shopify-section-group-footer-group").clientHeight;
let imageCounter = 0;
let blockOfImages= 20;

if(getImages.length > 0){
  const showImages = (imageIterator)=>{
      if(imageIterator<=getImages.length){
      
      for(imageCounter;imageCounter<=imageIterator;imageCounter++){
          getImages[imageCounter].classList.remove("d-golive-none")
          //console.log(imageCounter,imageIterator) 
      }
      blockOfImages+=20
  }else{
      for(imageCounter;imageCounter<=getImages.length; imageCounter++){
              getImages[imageCounter].classList.remove("d-golive-none")
          }
          //console.log("Nothing to do")
      }
    
  }
  
  showImages(blockOfImages)
  
  window.addEventListener('scroll', () =>{
      if(window.scrollY + window.innerHeight >= document.documentElement.scrollHeight- (footerHeight + footerPromotion)){
          //console.log("This is the scroll Y", window.scrollY)
          showImages(blockOfImages)
      }
  })
}
